import React from 'react'
import { AUTH_PERMISSION_KEYS } from 'constants/auth-permission-keys'
import RequestDeleteButton from 'redesign/components/atoms/Buttons/request-delete-button'
import TaskDetailsHeader from 'redesign/components/organisms/headers/task-details-header'
import { TASK_DETAILS_PAGE_ROOT_ID } from 'redesign/pages/task-details/constants'
import Page from '../Page'
import AbsenceAcceptDetails from '../absence-accept-details'
import { getActionButtons } from '../task-details-action-buttons/utils/get-action-buttons'
import { TASK_TYPE_TITLE } from '../task-details/constants'
import type { TaskDetailsProps, TaskTypeKey } from '../task-details/types'
import AbsenceRequestDetailsContent from './absence-request-details-content'
import useAbsenceRequestDetails from './use-absence-request-details'

const AbsenceRequestDetails: React.FC<TaskDetailsProps> = ({ task, refetch }) => {
  const {
    showDeleteButton,
    t,
    timelineItems,
    isOffice,
    onClickDeleteRequest,
    showConflicts,
    showAbsencePlannerDrawer,
    setShowAbsencePlannerDrawer,
    person,
    isBalanceDrawerOpen,
    setIsBalanceDrawerOpen,
    showForm,
    setShowForm,
    dateFrom,
    dateTo,
  } = useAbsenceRequestDetails(task, refetch)

  return showForm ? (
    <AbsenceAcceptDetails
      task={task}
      onGoBack={() => setShowForm(false)}
      refetch={refetch}
      timelineItems={timelineItems}
    />
  ) : (
    <Page
      hideNativeNavigation
      removeLastMargin
      rootId={TASK_DETAILS_PAGE_ROOT_ID}
      fullContentHeight
      header={
        <TaskDetailsHeader
          title={t(TASK_TYPE_TITLE[task.taskType as TaskTypeKey])}
          endContent={<RequestDeleteButton showDeleteButton={showDeleteButton} onClick={onClickDeleteRequest} />}
        />
      }
      footer={getActionButtons({
        task,
        refetch,
        workflowPermissions: AUTH_PERMISSION_KEYS.workflowAbsences,
        setShowAbsenceForm: setShowForm,
      })}
    >
      <AbsenceRequestDetailsContent
        items={timelineItems}
        dateFrom={dateFrom as string}
        dateTo={dateTo as string}
        isOffice={isOffice}
        showAbsencePlannerDrawer={showAbsencePlannerDrawer}
        setShowAbsencePlannerDrawer={setShowAbsencePlannerDrawer}
        previewPerson={person ?? {}}
        showConflicts={showConflicts}
        isBalanceDrawerOpen={isBalanceDrawerOpen}
        onCloseBalanceModal={() => setIsBalanceDrawerOpen(false)}
        task={task}
      />
    </Page>
  )
}

export default AbsenceRequestDetails
